// class CheckoutSubmit {
//     constructor() {
//         this.connectedCallback();
//     }

//     connectedCallback() {
//         // checkbox change (delegation-safe)
//         document.body.addEventListener('change', (e) => {
//             if (e.target && e.target.id === 'terms__conditions') {
//                 this.handleCheckoutButton();
//             }
//         });

//         // cart drawer render
//         document.body.addEventListener('cart:render', () => {
//             this.handleCheckoutButton();
//         });
//     }

//     handleCheckoutButton() {
//         const checkoutBtn = document.querySelector('.cart__checkout-button');
//         const checkbox = document.querySelector('#terms__conditions');

//         if (!checkoutBtn || !checkbox) return;

//         checkbox.checked
//             ? checkoutBtn.removeAttribute('disabled')
//             : checkoutBtn.setAttribute('disabled', 'disabled');
//     }
// }

// new CheckoutSubmit();


class CheckoutSubmit {
    constructor() {
        this.bindEvents();
    }

    bindEvents() {
        // checkbox toggle
        document.body.addEventListener('change', (e) => {
            if (e.target?.id === 'terms__conditions') {
                //this.updateButtonState();
                this.resetError();
            }
        });

        // checkout click (delegation-safe)
        document.body.addEventListener('click', (e) => {
            const btn = e.target.closest('.cart__checkout-button');
            if (!btn) return;

            const checkbox = document.querySelector('#terms__conditions');
            if (!checkbox) return;

            if (!checkbox.checked) {
                e.preventDefault();
                this.showError();
            }
        });

        // when drawer re-renders
        document.body.addEventListener('cart:render', () => {
            //this.updateButtonState();
            this.resetError();
        });
    }

    updateButtonState() {
        const btn = document.querySelector('.cart__checkout-button');
        const checkbox = document.querySelector('#terms__conditions');

        if (!btn || !checkbox) return;

        btn.disabled = !checkbox.checked;
    }

    showError() {
        const wrapper = document.querySelector('.terms-wrapper');
        const checkbox = document.querySelector('#terms__conditions');

        if (wrapper) wrapper.classList.add('has-error');
        if (checkbox) checkbox.classList.add('is-error');
    }

    resetError() {
        const wrapper = document.querySelector('.terms-wrapper');
        const checkbox = document.querySelector('#terms__conditions');

        if (wrapper) wrapper.classList.remove('has-error');
        if (checkbox) checkbox.classList.remove('is-error');
    }
}

new CheckoutSubmit();
